import { UPDATE_CHAT_POSITION, RESET_CHAT_POSITION } from '../mutation-types';
const pcDefaultPosition = {
    bottom: '30px',
    right: '30px'
};
const mobileDefaultPosition = {
    bottom: '15px',
    right: '15px'
};
export default {
    state: () => ({
        pcChatPosition: { ...pcDefaultPosition },
        mobileChatPosition: { ...mobileDefaultPosition }
    }),
    getters: {},
    mutations: {
        [UPDATE_CHAT_POSITION](state, { bottom, right, mBottom, mRight }) {
            bottom && (state.pcChatPosition.bottom = bottom);
            right && (state.pcChatPosition.right = right);
            mBottom && (state.mobileChatPosition.bottom = mBottom);
            mRight && (state.mobileChatPosition.right = mRight);
        },
        [RESET_CHAT_POSITION](state) {
            state.mobileChatPosition = { ...mobileDefaultPosition };
            state.pcChatPosition = { ...pcDefaultPosition };
        }
    },
    actions: {}
};
